import { api } from "./api";

const chapterServices = api.injectEndpoints({
  endpoints: (builder) => ({
    //save chapter
    saveChapter: builder.mutation({
      query: (formData) => ({
        url: "chapter/saveChapter",
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: formData,
      }),
      invalidatesTags: ["Chapter"],
    }),

    //get All Chapter with pagination
    getAllChaptersPagination: builder.mutation({
      query: (chapterData) => ({
        url: "chapter/getAllChapterPagination",
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: chapterData,
      }),
      invalidatesTags: ["Chapter"],
    }),

    //get All Chapter
    getAllChapters: builder.query({
      query: () => ({
        url: "chapter/getAllChapter",
      }),
      providesTags: ["Chapter"],
    }),

    //get all pending member
    getAllPendingMemberList: builder.mutation({
      query: (pendingMemberData) => ({
        url: "chapter/getPendingMemberList",
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: pendingMemberData,
      }),
      providesTags: ["Chapter"],
    }),
    assignChapterRewards: builder.mutation({
      query: (data) => ({
        url: "chapter/assignChapterReward",
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: data,
      }),
      providesTags: ["Chapter"],
    }),

    //get Chapter based on state
    getChapterBasedOnState: builder.mutation({
      query: (stateData) => ({
        url: "chapter/getChapterBasedOnState",
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: stateData,
      }),
    }),

    //get Chapter Details by Id
    getChapterDetailsById: builder.query({
      query: (id) => "chapter/get/" + id,
      providesTags: ["Chapter"],
    }),
    //get Chapter Role Details by Id
    getChapterRoleDetailsById: builder.query({
      query: (id) => "chapter/getRoleDetails/" + id,
      providesTags: ["Chapter"],
    }),
    getSIGGroupRoleDetailsById: builder.query({
      query: (id) => "sigGroup/getRoleDetails/" + id,
      providesTags: ["SIGGroup"],
    }),

    //Update Chapter
    updateChapter: builder.mutation({
      query: (data) => ({
        url: "chapter/update/" + data.id,
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: data.formData,
      }),
      invalidatesTags: ["Chapter"],
    }),

    //approve member
    aproveMember: builder.mutation({
      query: (formData) => ({
        url: "chapter/approveMember",
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: formData,
      }),
      invalidatesTags: ["Chapter"],
    }),
    //Enable disable chapter
    enableDisableChapter: builder.mutation({
      query: (id) => ({
        url: "chapter/enableDisable/" + id,
        method: "PUT",
        headers: { "Content-Type": "application/json" },
      }),
      invalidatesTags: ["Chapter"],
    }),

    //delete Member
    deleteMember: builder.mutation({
      query: (formData) => ({
        url: "chapter/rejectMember",
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: formData,
      }),
      invalidatesTags: ["Chapter"],
    }),

    //switch chapter
    switchChapter: builder.mutation({
      query: (formData) => ({
        url: "chapter/switchMember",
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: formData,
      }),
      invalidatesTags: ["Chapter"],
    }),

    //make admin
    makeAdmin: builder.mutation({
      query: (formData) => ({
        url: "chapter/makeChapterAdmin",
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: formData,
      }),
      invalidatesTags: ["Chapter"],
    }),

    //remove admin
    removeAdmin: builder.mutation({
      query: (formData) => ({
        url: "chapter/removeChapterAdmin",
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: formData,
      }),
      invalidatesTags: ["Chapter"],
    }),

    //getjoinmemberList
    getJoinMemberList: builder.mutation({
      query: (formData) => ({
        url: "chapter/getJoinMemberList ",
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: formData,
      }),
      invalidatesTags: ["Chapter"],
    }),

    getAllChapterFeed: builder.mutation({
      query: (data) => ({
        url: "chapterAllModules/getChapterAllModules",
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: data,
      }),
      providesTags: ["Chapter"],
    }),

    //update chapter
    updateChapterProfile: builder.mutation({
      query: (data) => ({
        url: "chapter/updateChapterAdmin/" + data.id,
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: data.formData || data.data,
      }),
      invalidatesTags: ["Chapter"],
    }),
    //update chapter
    leaveChapter: builder.mutation({
      query: (data) => ({
        url: "chapter/leaveMemberFromChapter",
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: data,
      }),
      invalidatesTags: ["Chapter"],
    }),

    deleteChapterbyId: builder.mutation({
      query: (data) => ({
        url: "chapter/delete/" + data?.id,
        method: "PUT",
        headers: { "Content-Type": "application/json" },
      }),
      invalidatesTags: ["Chapter"],
    }),
    //update chapter by admin
    approveRejectupdateChapter: builder.mutation({
      query: (data) => ({
        url: "chapter/approveRejectUpdateChapter/",
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: data,
      }),
      invalidatesTags: ["Chapter"],
    }),

    //get Chapter based on state
    getMonitorChapterShare: builder.mutation({
      query: (stateData) => ({
        url: "chapter/chapterShare",
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: stateData,
      }),
    }),
    payChaterShare: builder.mutation({
      query: (payData) => ({
        url: "chapterAmount/createChapterAmount",
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: payData,
      }),
    }),
    UpdatePayChaterShare: builder.mutation({
      query: ({ id, payData }) => ({
        url: "chapterAmount/update/" + id,
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: payData,
      }),
    }),
    DeletePayChaterShare: builder.mutation({
      query: (id) => ({
        url: "chapterAmount/delete/" + id,
        method: "PUT",
        headers: { "Content-Type": "application/json" },
      }),
    }),
    getChapterBasedOnChapterUrl: builder.mutation({
      query: (stateData) => ({
        url: "chapter/getChapterBasedOnChapterUrl",
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: stateData,
      }),
    }),
    getChapterByChapterUrl: builder.query({
      query: (stateData) => ({
        url: "chapter/getChapterBasedOnChapterUrl",
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: stateData,
      }),
    }),
  }),

  overrideExisting: false,
});

export const {
  useGetChapterBasedOnStateMutation,
  useGetAllChaptersPaginationMutation,
  useGetMonitorChapterShareMutation,
  useLazyGetAllChaptersQuery,
  useGetAllPendingMemberListMutation,
  useSaveChapterMutation,
  useDeleteMemberMutation,
  useAproveMemberMutation,
  useGetChapterDetailsByIdQuery,
  useLazyGetChapterDetailsByIdQuery,
  useUpdateChapterMutation,
  useSwitchChapterMutation,
  useMakeAdminMutation,
  useRemoveAdminMutation,
  useGetJoinMemberListMutation,
  useUpdateChapterProfileMutation,
  useLazyGetChapterRoleDetailsByIdQuery,
  useLazyGetSIGGroupRoleDetailsByIdQuery,
  useGetAllChapterFeedMutation,
  useDeleteChapterbyIdMutation,
  useLeaveChapterMutation,
  useApproveRejectupdateChapterMutation,
  useAssignChapterRewardsMutation,
  useGetChapterBasedOnChapterUrlMutation,
  useGetChapterByChapterUrlQuery,
  useEnableDisableChapterMutation,
  usePayChaterShareMutation,
  useUpdatePayChaterShareMutation,
  useDeletePayChaterShareMutation,
} = chapterServices;
